export type VoidFunction = () => void;
export type AsyncVoidFunction = () => Promise<void>;
export const noop = (): void => {};
export const asyncnoop = async (): Promise<void> => {};
